export const getKeySuggestions = (name) => {
  if (!name) return [];
  const clean = name.replace(/[^a-zA-Z0-9 ]/g, '').trim();
  const words = clean.split(/\s+/).filter(Boolean);
  const suggestions = [];

  const acronym = words.map(w => w[0]).join('').toUpperCase();
  suggestions.push(acronym);

  const firstWord = words[0].substring(0, 5).toUpperCase();
  if (!suggestions.includes(firstWord)) suggestions.push(firstWord);

  const combined = words.length > 1
    ? (words[0] + words[1]).substring(0, 6).toUpperCase()
    : words[0].substring(0, 6).toUpperCase();
  if (!suggestions.includes(combined)) suggestions.push(combined);

  if (suggestions.length < 3) {
    let i = 1;
    while (suggestions.length < 3) {
      const fallback = `${words[0].substring(0, 4).toUpperCase()}${i}`;
      if (!suggestions.includes(fallback)) suggestions.push(fallback);
      i++;
    }
  }

  return suggestions.slice(0, 3);
};

export const isValidUploadKey = (key) => /^[A-Z][A-Z0-9\-_]*[A-Z0-9]$/.test(key) && key.length >= 2;

export const getProjectNameFromStorage = () => {
  try {
    const draft = localStorage.getItem('robitest_onboarding_draft_v1');
    if (!draft) return '';
    const parsed = JSON.parse(draft);
    return parsed?.data?.project?.name || '';
  } catch {
    return '';
  }
};


export const normalizeKey = (val) => {
  return val
    .toUpperCase()
    .replace(/[^A-Z0-9\-_]/g, '');
};